import { Storage, Drivers } from '@ionic/storage'

import { SANDBOX } from '../sandbox/sandbox'

/**
 * En bac à sable, le stockage vit en mémoire : l'aperçu ne touche pas à la
 * vraie app de ce navigateur (jeton, langue, événement).
 */
const memory = new Map<any, any>()
const memoryStorage = {
    create: () => undefined,
    set: async (key: any, val: any) => void memory.set(key, val),
    get: async (key: any) => memory.get(key) ?? null,
    remove: async (key: any) => void memory.delete(key),
    clear: async () => memory.clear()
}

let storage: any = SANDBOX ? memoryStorage : undefined

/**
 * ionics storage wrapper for localstorage and indexeddb
 */
export const createStore = (name = '__mydb') => {
    if (SANDBOX) {
        storage = memoryStorage
        return
    }
    storage = new Storage({
        name,
        driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage]
    })

    storage.create()
}

export const set = (key: any, val: any) => {
    storage.set(key, val)
}

export const get = async (key: any) => {
    const val = await storage.get(key)
    return val
}

export const remove = async (key: any) => {
    await storage.remove(key)
}

export const clear = async () => {
    await storage.clear()
}

export const setObject = async (key: any, id: any, val: any) => {
    const all = await storage.get(key)
    const objIndex = await all.findIndex((a: any) => parseInt(a.id) === parseInt(id))

    all[objIndex] = val
    set(key, all)
}

export const removeObject = async (key: any, id: any) => {
    const all = await storage.get(key)
    const objIndex = await all.findIndex((a: any) => parseInt(a.id) === parseInt(id))

    all.splice(objIndex, 1)
    set(key, all)
}

export const getObject = async (key: any, id: any) => {
    const all = await storage.get(key)
    const obj = await all.filter((a: any) => parseInt(a.id) === parseInt(id))[0]
    return obj
}
